import { LiteUIContext } from '@/contexts/LiteUIContext';
import { useContext, useMemo } from 'react';
export const FPSBar = () => {
    const isDevelopment = useMemo<boolean>(
        () => process.env.NODE_ENV === 'development',
        []
    );
    const { fps } = useContext(LiteUIContext);
    const color = useMemo(() => {
        if (fps < 20) {
            return 'red';
        }
        if (fps < 30) {
            return 'orange';
        }
        if (fps < 40) {
            return 'yellow';
        }
        return 'green';
    }, [fps]);
    return isDevelopment ? (
        <div
            style={{
                pointerEvents: 'none',
                position: 'absolute',
                top: '0px',
                zIndex: 10000,
                color: color,
            }}
        >{`${fps}fps`}</div>
    ) : (
        <></>
    );
};
